import { VIDEO_CODEC_CANDIDATES } from "./video-codecs.js";

export const VIDEO_PACKET_CONFIG = 1;
export const VIDEO_PACKET_FRAME = 2;
export const VIDEO_KEY_FRAME = 1;
const VIDEO_FRAME_HEADER_BYTES = 26;

export function videoConfigPacket(decoderConfig, track, fallbackCodec) {
  const description = decoderConfig?.description ? toBase64(new Uint8Array(decoderConfig.description)) : undefined;
  const body = new TextEncoder().encode(JSON.stringify({ codec: decoderConfig?.codec || fallbackCodec.codec, width: track.width, height: track.height, description }));
  const packet = new Uint8Array(body.byteLength + 1); packet[0] = VIDEO_PACKET_CONFIG; packet.set(body, 1);
  return packet;
}

export function decodeVideoConfig(packet) {
  try {
    const config = JSON.parse(new TextDecoder().decode(packet.slice(1)));
    if (!VIDEO_CODEC_CANDIDATES.some(candidate => candidate.codec === config?.codec) || !Number.isInteger(config.width) || !Number.isInteger(config.height)) throw new Error("invalid video config");
    return config;
  } catch (error) {
    throw new Error(`invalid video configuration: ${error?.message || String(error)}`);
  }
}

export function videoFramePacket(chunk) {
  const encoded = new Uint8Array(chunk.byteLength); chunk.copyTo(encoded);
  const packet = new Uint8Array(VIDEO_FRAME_HEADER_BYTES + encoded.byteLength);
  packet[0] = VIDEO_PACKET_FRAME; packet[1] = chunk.type === "key" ? VIDEO_KEY_FRAME : 0;
  const view = new DataView(packet.buffer);
  view.setFloat64(2, chunk.timestamp);
  view.setFloat64(10, chunk.duration || 0);
  view.setFloat64(18, Date.now() * 1000);
  packet.set(encoded, VIDEO_FRAME_HEADER_BYTES); return packet;
}

export function decodeVideoFrame(payload) {
  if (payload.byteLength < VIDEO_FRAME_HEADER_BYTES) return undefined;
  const view = new DataView(payload.buffer, payload.byteOffset, payload.byteLength);
  return {
    keyFrame: Boolean(payload[1] & VIDEO_KEY_FRAME),
    timestamp: view.getFloat64(2), duration: view.getFloat64(10), encodedAt: view.getFloat64(18),
    data: payload.slice(VIDEO_FRAME_HEADER_BYTES)
  };
}

function toBase64(bytes) {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary);
}

export function fromBase64(value) {
  const binary = atob(value); const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes;
}
